(function () {
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-ib-accordion-toggle]');
    if (!toggle) return;

    var panel = document.getElementById(toggle.getAttribute('aria-controls'));
    var open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
    if (panel) panel.hidden = open;
  });

  var stickyAtc = document.querySelector('[data-ib-sticky-atc]');
  var productForm = document.querySelector('[data-product-form]');
  if (stickyAtc && productForm && 'IntersectionObserver' in window) {
    var stickyObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyAtc.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    stickyObserver.observe(productForm);

    var stickyButton = stickyAtc.querySelector('button');
    if (stickyButton) {
      stickyButton.addEventListener('click', function () {
        var submit = productForm.querySelector('[data-add-to-cart]');
        if (submit) submit.click();
      });
    }
  }

  var recentlyViewed = document.querySelector('[data-ib-recently-viewed]');
  if (recentlyViewed && window.localStorage) {
    var key = 'ib_recently_viewed';
    var currentProduct = {
      handle: recentlyViewed.getAttribute('data-product-handle'),
      title: recentlyViewed.getAttribute('data-product-title'),
      url: recentlyViewed.getAttribute('data-product-url'),
      image: recentlyViewed.getAttribute('data-product-image')
    };
    var previous = [];

    try {
      previous = JSON.parse(window.localStorage.getItem(key)) || [];
    } catch (error) {
      previous = [];
    }

    var list = recentlyViewed.querySelector('[data-ib-recently-viewed-list]');
    var itemsToRender = previous.filter(function (item) {
      return item.handle && item.handle !== currentProduct.handle;
    }).slice(0, 6);

    if (itemsToRender.length && list) {
      function escapeHtml(value) {
        return String(value || '').replace(/[&<>"']/g, function (character) {
          return {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#39;'
          }[character];
        });
      }

      list.innerHTML = itemsToRender.map(function (item) {
        var title = escapeHtml(item.title);
        var url = escapeHtml(item.url);
        var imageUrl = escapeHtml(item.image);
        var image = imageUrl ? '<img src="' + imageUrl + '" alt="' + title + '" loading="lazy">' : '';
        return '<a class="ib-recent-card" href="' + url + '">' + image + '<span>' + title + '</span></a>';
      }).join('');
      recentlyViewed.hidden = false;
    }

    var next = [currentProduct].concat(previous.filter(function (item) {
      return item.handle !== currentProduct.handle;
    })).slice(0, 8);
    window.localStorage.setItem(key, JSON.stringify(next));
  }

  Array.prototype.forEach.call(document.querySelectorAll('[data-ib-hero-slideshow]'), function (hero) {
    var slides = hero.querySelectorAll('.ib-hero__slide');
    if (slides.length < 2) return;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var index = 0;
    var interval;

    function showSlide(nextIndex) {
      slides[index].classList.remove('is-active');
      index = (nextIndex + slides.length) % slides.length;
      slides[index].classList.add('is-active');
    }

    function start() {
      if (reduceMotion) return;
      window.clearInterval(interval);
      interval = window.setInterval(function () {
        showSlide(index + 1);
      }, 5000);
    }

    var previous = hero.querySelector('[data-ib-hero-prev]');
    var next = hero.querySelector('[data-ib-hero-next]');

    if (previous) {
      previous.addEventListener('click', function () {
        showSlide(index - 1);
        start();
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        showSlide(index + 1);
        start();
      });
    }

    start();
  });

  var header = document.querySelector('[data-ib-header]');
  if (!header) return;

  var mobileMenu = document.querySelector('[data-ib-mobile-menu]');
  var openButton = document.querySelector('[data-ib-menu-open]');
  var closeButton = document.querySelector('[data-ib-menu-close]');

  function syncHeader() {
    if (window.scrollY > 40) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  }

  function setMenu(open) {
    header.classList.toggle('is-open', open);
    if (mobileMenu) {
      mobileMenu.classList.toggle('is-open', open);
      mobileMenu.setAttribute('aria-hidden', open ? 'false' : 'true');
    }
    if (openButton) {
      openButton.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    document.documentElement.classList.toggle('ib-menu-open', open);
  }

  syncHeader();
  window.addEventListener('scroll', syncHeader, { passive: true });

  if (openButton) {
    openButton.addEventListener('click', function () {
      setMenu(true);
    });
  }

  if (closeButton) {
    closeButton.addEventListener('click', function () {
      setMenu(false);
    });
  }

  if (mobileMenu) {
    mobileMenu.addEventListener('click', function (event) {
      if (event.target.tagName === 'A') setMenu(false);
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') setMenu(false);
  });

})();
